module.exports = __webpack_public_path__ + "img/black-board.db3c081c.png";